import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { getResolvedAttributes } from '@atlaskit/link-analytics/resolved-attributes';
import { ANALYTICS_CHANNEL } from '../../../../../../../../utils/analytics';
var createUiRelatedLinksViewedEventPayload = function createUiRelatedLinksViewedEventPayload(_ref) {
  var relatedLinksCount = _ref.relatedLinksCount;
  return {
    action: 'viewed',
    actionSubject: 'relatedLinks',
    eventType: 'ui',
    attributes: {
      relatedLinksCount: relatedLinksCount
    }
  };
};
export var fireRelatedLinksViewedEvent = function fireRelatedLinksViewedEvent(createAnalyticsEvent) {
  return function (attributes) {
    var payload = createUiRelatedLinksViewedEventPayload(attributes);
    if (payload) {
      createAnalyticsEvent(_objectSpread({}, payload)).fire(ANALYTICS_CHANNEL);
    }
  };
};
export var RelatedUrlItemAnalyticsContext = function RelatedUrlItemAnalyticsContext(props) {
  var children = props.children,
    details = props.details;

  /**
   * We don't really need the `url` to get the attributes here so set
   * it to an empty string to just make typescript happy
   */
  var attributes = getResolvedAttributes({
    url: ''
  }, details);
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      attributes: attributes,
      component: 'relatedLink'
    }
  }, children);
};